import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "bizpandit-ui";
import { useAuthStore } from "@/stores/authStore";
import { pickHomeForRole } from "@/app/router/roleHome";
import OtpVerifyPanel from "./OtpVerifyPanel";

/**
 * The catch-up screen for clients who registered before verification was
 * required (2026-08-22). AuthGuard sends them here and keeps them here until
 * the number is confirmed.
 *
 * NO BACKEND CHANGE WAS NEEDED FOR THIS. /auth/verify-otp already handles an
 * existing user: it sets phone_verified when it is false and issues a fresh
 * session. So the same OtpVerifyPanel used by phone login does the whole job
 * with intent LOGIN — the "login" it performs simply replaces the session the
 * client already had, now carrying phoneVerified: true.
 */
export default function VerifyPhonePage() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);

  if (!user) return null;

  return (
    <div className="min-h-screen bg-surface px-5 py-12">
      <div className="mx-auto max-w-md">
        <h1 className="m-0 text-[22px] font-semibold text-navy">
          Confirm your mobile number
        </h1>
        <p className="mt-2 mb-6 text-[13px] leading-relaxed text-slate-500">
          We need to confirm the number on your account before you continue.
          It is a one-time step — we will send a 6-digit code to your WhatsApp.
        </p>

        <Card className="border border-linegray rounded-[14px]">
          <CardContent className="p-4">
            {user.phone ? (
              <OtpVerifyPanel
                mobile={user.phone}
                intent="LOGIN"
                autoSend
                onVerified={() => navigate(pickHomeForRole(user.role), { replace: true })}
              />
            ) : (
              /*
               * Three client accounts have no phone at all. Sending them round
               * a verification loop they cannot complete would lock them out
               * with no way forward, so they get an explanation instead.
               */
              <p className="text-[13px] leading-relaxed text-navy2">
                There is no mobile number on your account, so we cannot send a
                code. Please contact your consultant to have it added — they can
                do it in a moment, and you will be able to sign in straight
                after.
              </p>
            )}
          </CardContent>
        </Card>

        <p className="mt-4 text-center text-[12px] text-slate-400">
          Not your number? Contact your consultant before confirming.
        </p>
      </div>
    </div>
  );
}
